import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/*
 * Licensed Materials - Property of IBM
 * 5724-Q36
 * (c) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { useRef, useState } from 'react';

var useParentDimensions = function useParentDimensions(hooks) {
  var rootRef = useRef();
  var headRef = useRef();
  var innerListRef = useRef();
  var listRef = useRef();

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      tableHeight = _useState2[0],
      setTableHeight = _useState2[1];

  var useInstance = function useInstance(instance) {
    var DatagridActions = instance.DatagridActions,
        DatagridBatchActions = instance.DatagridBatchActions,
        totalColumnsWidth = instance.totalColumnsWidth,
        DatagridPagination = instance.DatagridPagination;

    var handleResize = function handleResize() {
      var parent = rootRef && rootRef.current && rootRef.current.parentElement;

      if (!parent) {
        return;
      }

      var parentHeight = parent.clientHeight;
      var parentWidth = parent.clientWidth;
      var headHeight = headRef && headRef.current && headRef.current.clientHeight;
      var parentStyles = window.getComputedStyle(parent);
      var parentMarginBottom = parseFloat(parentStyles.getPropertyValue('margin-bottom'));
      var parentPaddingBottom = parseFloat(parentStyles.getPropertyValue('padding-bottom'));
      var parentMarginTop = parseFloat(parentStyles.getPropertyValue('margin-top'));
      var parentPaddingTop = parseFloat(parentStyles.getPropertyValue('padding-top'));
      var datagridActionsHeight = DatagridActions || DatagridBatchActions ? 48 : 0;
      var datagridPaginationHeight = DatagridPagination ? 48 : 0;
      var hasHorizontalScrollbar = parentWidth < totalColumnsWidth;
      var horizontalScrollbarHolder = hasHorizontalScrollbar ? 16 : 0;
      var newHeight = parentHeight - headHeight - parentMarginBottom - parentPaddingBottom - parentMarginTop - parentPaddingTop - datagridActionsHeight - datagridPaginationHeight - horizontalScrollbarHolder;
      setTableHeight(newHeight);
    };

    Object.assign(instance, {
      tableHeight: tableHeight,
      rootRef: rootRef,
      headRef: headRef,
      innerListRef: innerListRef,
      handleResize: handleResize,
      listRef: listRef
    });
  };

  hooks.useInstance.push(useInstance);
};

export default useParentDimensions;